import { Link } from "react-router-dom";
import NewsletterSignup from "@/components/NewsletterSignup";

const COLS = [
  {
    title: "Content",
    links: [
      { label: "Read", to: "/" },
      { label: "Locker Room", to: "/locker-room" },
      { label: "The Rulebook", to: "/rulebook" },
      { label: "Hot Take Huddle", to: "/locker-room" },
    ],
  },
  {
    title: "Tools",
    links: [
      { label: "Quick Plays", to: "/quick-plays" },
      { label: "Starter Kit", to: "/starter-kit" },
      { label: "My Account", to: "/account" },
      { label: "Coaches", to: "/category/coaches-corner" },
      { label: "Parents", to: "/category/parent-sideline" },
      { label: "Shop", to: "/shop" },
      { label: "ChalkOS", to: "/chalkos" },
    ],
  },
  {
    title: "Voluntold",
    links: [
      { label: "About Coach Kyto", to: "/about" },
      { label: "Nominate", to: "/nominate" },
      { label: "@VoluntoldHQ", href: "https://instagram.com/voluntoldhq" },
    ],
  },
];

const LEGAL = [
  { label: "Terms", to: "/legal/terms" },
  { label: "Privacy", to: "/legal/privacy" },
  { label: "Refund", to: "/legal/refund" },
  { label: "Cookies", to: "/legal/cookies" },
  { label: "Disclaimer", to: "/disclaimer" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[color:var(--vt-dark)] vt-grain text-[color:var(--vt-body-on-dark)]" data-testid="footer">
      {/* torn-paper edge where cream content meets the dark footer */}
      <svg className="block w-full h-5" viewBox="0 0 1200 20" preserveAspectRatio="none" aria-hidden="true">
        <path
          d="M0,20 L0,10 L100,6 L200,12 L300,7 L400,13 L500,5 L600,11 L700,6 L800,12 L900,8 L1000,13 L1100,6 L1200,10 L1200,20 Z"
          fill="var(--vt-cream)"
        />
      </svg>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* brand + newsletter */}
          <div className="lg:col-span-1 max-w-sm">
            <img
              src="/brand/logos/voluntoldhq-lockup-horizontal-on-dark.svg"
              alt="VoluntoldHQ — Lead Today. Impact Tomorrow."
              className="w-full max-w-[300px] lg:max-w-[420px] h-auto"
            />
            <div className="mt-6" id="join-the-sideline">
              <span className="vt-eyebrow block mb-3">Join the sideline</span>
              <NewsletterSignup source="footer" tone="dark" showCopy={false} testId="footer-newsletter" />
            </div>
          </div>

          {/* link columns */}
          <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <div className="vt-eyebrow">{col.title}</div>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.href ? (
                        <a
                          href={l.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                          className="font-[Nunito_Sans] font-bold text-sm text-[color:var(--vt-white)] hover:text-[color:var(--vt-amber)] transition-colors"
                        >
                          {l.label}
                        </a>
                      ) : (
                        <Link
                          to={l.to}
                          data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                          className="font-[Nunito_Sans] font-bold text-sm text-[color:var(--vt-white)] hover:text-[color:var(--vt-amber)] transition-colors"
                        >
                          {l.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* legal (kept for compliance access) */}
        <div className="mt-12 pt-6 border-t border-[color:var(--vt-rule-dark)] flex flex-wrap gap-x-5 gap-y-2">
          {LEGAL.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`footer-legal-${l.label.toLowerCase()}`}
              className="font-[Nunito_Sans] text-xs text-[color:var(--vt-graphite)] hover:text-[color:var(--vt-white)] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </div>

        {/* mono bottom row */}
        <div className="mt-6 flex flex-col sm:flex-row justify-between gap-2" style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
          <span className="text-[11px] tracking-[0.18em] uppercase text-[color:var(--vt-graphite)]">
            <Link to="/admin" aria-label="Scout's Desk" data-testid="footer-admin-link" className="text-inherit hover:text-inherit no-underline cursor-default" tabIndex={-1}>&copy;</Link>{" "}
            2026 VoluntoldHQ
          </span>
          <span className="text-[11px] tracking-[0.18em] uppercase text-[color:var(--vt-graphite)]" data-testid="footer-tagline">
            For everyone who got voluntold.
          </span>
        </div>
      </div>
    </footer>
  );
}
